/**
 * 渠道结构健康诊断 - 常量数据
 * 六维度 × 3题 = 18项诊断指标
 */

// AI可信度标记
export const AI_CONFIDENCE = {
  br1: 'high', dv1: 'high', fl1: 'high', br2: 'high', ft2: 'high',
  de1: 'high', dv3: 'high', fl2: 'mid', ft1: 'mid', dv2: 'mid',
  br3: 'mid', ev1: 'mid', ev2: 'low', ev3: 'low', fl3: 'low',
  de2: 'low', de3: 'low', ft3: 'low'
}

// AI可信度中文标签
export const CONFIDENCE_LABELS = {
  high: 'AI评分',
  mid: 'AI推断',
  low: '默认值'
}

// 六维度定义
export const DIMENSIONS = [
  {
    id: 'breadth',
    name: '渠道覆盖完整性',
    weight: 1.15,
    desc: '目标用户所在的平台/业态，品牌是否都有布局？',
    theory: '三维变量·广度',
    harmMessage: '用户搜不到你，下一秒就下单了竞品。每空一个主流平台，等于在该平台数千万活跃用户面前彻底隐身。',
    questions: [
      { id: 'br1', text: '品牌在目标用户活跃的主流线上平台均有渠道覆盖', low: '仅1个平台有渠道', high: '覆盖5+个平台或业态' },
      { id: 'br2', text: '品牌在各平台内的品类/类目覆盖完整', low: '核心品类缺位严重', high: '所有核心品类均有覆盖' },
      { id: 'br3', text: '新兴渠道有规划地纳入渠道结构', low: '从未考虑新渠道', high: '已有清晰的新渠道拓展路线图' }
    ]
  },
  {
    id: 'flatness',
    name: '渠道层级扁平度',
    weight: 1.2,
    desc: '从品牌到消费者的中间环节是否足够短？',
    theory: '三维变量·长度',
    harmMessage: '每多一级分销商，品牌利润就被割走10%-30%。更致命的是——你根本不知道终端用户是谁、在哪、买了什么。',
    questions: [
      { id: 'fl1', text: '品牌的DTC渠道已建立且持续运营，占比在提升', low: '完全依赖第三方平台', high: 'DTC占比超40%且在增长' },
      { id: 'fl2', text: '渠道结构中不存在不必要的多级分销层级', low: '存在3+级分销层级', high: '全部为零级或一级渠道' },
      { id: 'fl3', text: '品牌能直接触达终端用户数据', low: '完全无法获取终端用户数据', high: '拥有全渠道用户数据中台' }
    ]
  },
  {
    id: 'density',
    name: '渠道密度均衡性',
    weight: 1.05,
    desc: '各渠道内的店铺/触点密度是否合理？',
    theory: '三维变量·宽度',
    harmMessage: '同一平台几十家店卖一样的东西，你让消费者信谁？当消费者看到你的产品价格从30元蹦到80元，信任就碎了。',
    questions: [
      { id: 'de1', text: '各平台的授权店铺数量经过规划', low: '无管控的密集分布', high: '数量经过精确规划' },
      { id: 'de2', text: '渠道密度与实际市场需求匹配', low: '内部价格战频发', high: '各渠道利润空间健康' },
      { id: 'de3', text: '渠道之间存在明确的差异化定位', low: '所有渠道卖同样的货', high: '各渠道有清晰的品类和客群定位' }
    ]
  },
  {
    id: 'diversity',
    name: '渠道业态多样性',
    weight: 1.1,
    desc: '渠道类型的丰富程度是否足够分散风险？',
    theory: '三维变量·广度（细分）',
    harmMessage: '平台涨流量费、改算法、调整类目规则，任何一项都能让你收入腰斩——而你没有备用渠道可以缓冲。',
    questions: [
      { id: 'dv1', text: '品牌同时布局了货架电商、内容电商、社交电商等多种线上业态', low: '仅有一种业态类型', high: '覆盖4+种线上业态' },
      { id: 'dv2', text: '不同业态的渠道之间有互补关系', low: '各渠道完全独立无协同', high: '内容-社交-货架形成闭环' },
      { id: 'dv3', text: '品牌对单一平台/业态的GMV依赖度在安全线以内', low: '单一渠道占80%+GMV', high: '最大单一渠道不超过35%' }
    ]
  },
  {
    id: 'fit',
    name: '渠道结构适配性',
    weight: 1.15,
    desc: '渠道结构是否与产品特性、目标用户、企业能力匹配？',
    theory: '渠道设计八要素',
    harmMessage: '在错误的地方、用错误的方式、卖给了错误的人——品牌定位被稀释，消费者对你的价值认知会不可逆地下滑。',
    questions: [
      { id: 'ft1', text: '线上渠道结构与产品品类特性相匹配', low: '渠道结构与品类特性矛盾', high: '渠道结构完全贴合品类特性' },
      { id: 'ft2', text: '各渠道的客群画像与品牌目标用户高度一致', low: '客群与目标用户偏差大', high: '各渠道客群精准匹配目标用户' },
      { id: 'ft3', text: '渠道结构在品牌团队资源和能力可支撑范围内', low: '多个渠道处于无人运营状态', high: '每个渠道都有专职团队运营' }
    ]
  },
  {
    id: 'evolution',
    name: '渠道结构演进力',
    weight: 1.05,
    desc: '渠道结构是否随生命周期阶段动态调整？',
    theory: '渠道结构生命周期',
    harmMessage: '市场在变，你的渠道结构没变——这是最危险的信号。没有演进机制的品牌，是被自己的惯性拖死的。',
    questions: [
      { id: 'ev1', text: '品牌清楚当前所处生命周期阶段，且渠道结构与阶段特征匹配', low: '不清楚当前处于哪个阶段', high: '有明确的生命周期判断和策略' },
      { id: 'ev2', text: '有定期的渠道结构复盘机制', low: '从不审视渠道结构', high: '每季度进行渠道结构盘点' },
      { id: 'ev3', text: '渠道结构有明确的演进方向', low: '无结构性演进规划', high: '有3年渠道结构演进路线图' }
    ]
  }
]

// 行业列表
export const INDUSTRIES = [
  '服饰内衣', '食品饮料', '美妆个护', '3C数码', '家用电器',
  '家居家装', '母婴用品', '运动户外', '珠宝配饰/钟表', '鞋靴箱包',
  '日用百货', '宠物生活', '酒类', '生鲜果蔬', '图书文教',
  '玩具乐器', '汽车用品', '医药健康', '家纺布艺', '厨房厨具',
  '农资园艺', '成人/计生', '其他'
]

// 优化建议库（按维度+严重程度索引）
export const RECOMMENDATIONS = {
  breadth: {
    urgent: { title: '紧急填补渠道覆盖空白', desc: '品牌在多个主流平台缺席，用户找不到购买入口。立即启动天猫/京东/拼多多中匹配品牌定位的1-2个平台入驻流程。' },
    improve: { title: '补齐渠道覆盖缺口', desc: '评估缺失平台的价值和入驻成本，优先选择用户重合度高、品类匹配度好的平台。' },
    optimize: { title: '完善覆盖深度', desc: '渠道平台入驻已较完整，建议细化各平台内部的品类和关键词覆盖。' }
  },
  flatness: {
    urgent: { title: '启动DTC渠道建设', desc: '过度依赖第三方平台分销、层级过长将导致利润被多层分食且无法掌握用户数据。建议从微信小程序/企业微信起步。' },
    improve: { title: '加速渠道扁平化进程', desc: '加大DTC渠道投入比例，减少不必要的分销层级。加强终端用户数据回收能力。' },
    optimize: { title: '巩固扁平化优势', desc: 'DTC渠道建设已有成效，建议通过会员体系、订阅模式等增强用户粘性。' }
  },
  density: {
    urgent: { title: '整顿渠道密度乱象', desc: '同一平台存在过多店铺/分销商导致严重内耗和价格混乱。立即进行渠道盘点，清理无授权店铺。' },
    improve: { title: '优化渠道密度管控', desc: '为每个平台设定授权店铺数量上限，确保各渠道有明确的差异化定位。' },
    optimize: { title: '精细化密度管理', desc: '建立渠道密度动态调整机制，根据各平台GMV、利润率定期评估。' }
  },
  diversity: {
    urgent: { title: '打破渠道业态单一困局', desc: '仅依赖单一业态类型存在巨大结构性风险。立即布局内容电商或社交电商。' },
    improve: { title: '丰富渠道业态组合', desc: '在现有业态基础上拓展新业态类型，强化不同业态之间的协同关系。' },
    optimize: { title: '深化业态协同效应', desc: '各业态渠道布局已较完整，建议通过种草→扩散→成交→复购的闭环设计提升协同效率。' }
  },
  fit: {
    urgent: { title: '重新审视渠道与产品的匹配度', desc: '现有渠道结构与产品品类特性、目标用户严重不匹配。果断退出不匹配的渠道。' },
    improve: { title: '提升渠道-产品-用户三方匹配度', desc: '分析各渠道客群画像与目标用户的差距，调整渠道策略或产品策略。' },
    optimize: { title: '持续优化结构适配性', desc: '建立适配度定期评估机制，动态调整渠道结构。' }
  },
  evolution: {
    urgent: { title: '建立渠道结构复盘与迭代机制', desc: '渠道结构长期缺乏审视和调整，可能严重偏离当前市场环境。立即进行全面渠道结构盘点。' },
    improve: { title: '建立常态化的结构复盘机制', desc: '设定季度渠道结构复盘流程，培养团队的结构化思维。' },
    optimize: { title: '制定渠道结构演进路线图', desc: '基于行业趋势和企业战略，制定3年渠道结构演进路线图。' }
  }
}

// 一期止血策略
export const PHASE1_ACTIONS = {
  breadth: '启动核心平台入驻',
  flatness: '启动DTC小程序建设',
  density: '渠道盘点+数量上限管控',
  diversity: '布局第一个新业态渠道',
  fit: '退出最不匹配的渠道',
  evolution: '完成首次渠道结构盘点'
}

// 二期调结构策略
export const PHASE2_ACTIONS = {
  breadth: '完成所有主流平台覆盖',
  flatness: 'DTC占比提升至20%+',
  density: '实现各渠道差异化定位',
  diversity: '覆盖3+种线上业态',
  fit: '各渠道客群匹配度达80%+',
  evolution: '建立季度结构复盘机制'
}

// 默认评分（无数据时使用）
export const DEFAULT_SCORES = {
  br1: 3, br2: 3, br3: 3,
  fl1: 2, fl2: 3, fl3: 3,
  de1: 3, de2: 3, de3: 3,
  dv1: 2, dv2: 3, dv3: 3,
  ft1: 3, ft2: 3, ft3: 3,
  ev1: 3, ev2: 3, ev3: 3
}

// 诊断等级判定
export function getGrade(total) {
  if (total >= 85) return { grade: '健康', code: 'cg', detail: '渠道结构强健，各维度均衡，具备抗风险能力和可持续增长潜力。系统评级：正常。' }
  if (total >= 70) return { grade: '关注', code: 'cb', detail: '结构基本成型，但局部存在应力点——不改暂时还行，但隐患会随时间扩大。系统评级：观察。' }
  if (total >= 50) return { grade: '警告', code: 'ca', detail: '渠道结构已出现多处薄弱环节。价格体系、用户资产、市场份额中至少有一项正在无声流失。系统评级：告警。' }
  return { grade: '危急', code: 'cr', detail: '这不是优化问题，是生存问题。渠道结构已经严重失衡。系统评级：危急。立即行动是唯一选项。' }
}

// 仪表盘颜色计算
export function getGaugeColor(score) {
  if (score >= 85) return '#00F5A0'
  if (score >= 70) return '#00D4FF'
  if (score >= 50) return '#FFB800'
  return '#FF3B5C'
}

// 获取维度优先级标签
export function getPriorityLabel(priority) {
  return { urgent: '紧急', improve: '改善', optimize: '优化' }[priority] || priority
}

// 获取优先级颜色
export function getPriorityColor(priority) {
  return { urgent: '#FF3B5C', improve: '#FFB800', optimize: '#00D4FF' }[priority] || '#00D4FF'
}
